import { styled } from '@mui/material/styles';

import AtomGrid from '../../../components/atoms/AtomGrid';
import { styleConfigs } from '../../../components/resources/styleConfigs';

export const ProfileContainer = styled(AtomGrid)(() => ({
  display: 'flex',
}));

export const ProfileDetails = styled(AtomGrid)(() => ({
  paddingLeft: styleConfigs.marginPadding.custom16,
}));
